import React from 'react'
import {Launcher} from 'react-chat-window'
import {Button} from 'react-bootstrap'
import chatLogo from './chatLogo.png'
import filter from './sw.js'

export default function MyChat(props){
    const [messages, setMessages] = React.useState([])
    const [useState, setUseState] = React.useState(false)
    const [messageHistory, setMessageHistory] = React.useState("")
    const [show, setShow] = React.useState(true)
    const [resentMessages, setResentMessages] = React.useState([])
    const [recieved400, setRecieved400] = React.useState(false)
    const [recentMessage, setRecentMessage] = React.useState("")

    React.useEffect(() => {
        fetch("https://f44u6ncsca.execute-api.us-east-1.amazonaws.com/Dev/config").then(res => res.json()).then(res2 => {
            setUseState(res2.state)
        })
    }, [])

    function _handleClick(){
        setShow(!show);
    }

    function filterMessage(message){
        var splitMessage = message.split(" ")
        splitMessage.map((word, index) => {
            if (filter.has(word.toLowerCase())) {
                splitMessage[index] = "rude words"
            }
        })
        const joinMessage = splitMessage.join(" ")
        return joinMessage
    }

    function _onMessageWasSent(message) {
        if (message.type === "text" && (message.data.text.split(" ").join("") !== "")) {
            
            const filteredMessage = filterMessage(message.data.text)
            const message1 = {
                author: "me",
                type: "text",
                data: {text: filteredMessage}
            }
            setMessages([...messages, message1])
            
            const responseUrl = "https://f44u6ncsca.execute-api.us-east-1.amazonaws.com/Dev/response"

            var requestMessage;
            var repeat = false;
        
            if (message.data.text === recentMessage) {
                requestMessage = messageHistory.substring(0, messageHistory.length - (message.data.text.length + 4))
                repeat = true;
            }
            else {
                requestMessage = useState ? messageHistory + `Q:${filteredMessage}` : `Q:${filteredMessage}` 
            }

            console.log(requestMessage)

            const requestOptions = {
                method: 'POST',
                body: JSON.stringify({"message": requestMessage, module: props.module, "repeated": repeat}) 
            }
            
            fetch(responseUrl, requestOptions).then(res => res.json()).then(res2 => {
                if (res2.message != null) {
                    if (!recieved400 && useState) {
                        setMessages([...messages])
                        setRecieved400(true)
                        setMessageHistory("")
                        setResentMessages([...resentMessages, message])
                    }
                    else {
                        const message2 = {
                            author: 'them',
                            type: 'text',
                            data: {text: "Whoa, did you paste your entire dissertation in there? Please ask a shorter question 😁"}
                        }
                        setMessages([...messages, message, message2])
                    }
                }
                else {
                    const response = res2[props.module].text
                    const gpt_score = res2[props.module].gpt_score.toFixed(2)
                    if (response.split(" ").join("") !== "") {
                        const message2 = {
                            author: 'them',
                            type: 'text',
                            data: { text: response }
                        }
                        const message3 = {
                            author: 'me',
                            type: 'text',
                            data: {text: `GPT-3 Ethicality Score: ${gpt_score}`}
                        }
                        setMessages([...messages, message1, message3, message2])
                        const updatedHistory = repeat ? requestMessage + `-A:${response}|` : messageHistory + `Q:${message.data.text}-A:${response}|`
                        console.log("History " + updatedHistory)
                        setMessageHistory(updatedHistory)
                        setRecieved400(false)
                    }
                }
                setRecentMessage(message.data.text)
            })
        }
        else if (message.type === "emoji") {
            setMessages([...messages, message])
        }
    }

    return (
        <div>
            <div>
                <Button size="sm" variant="light" style={{border: "1px solid black", margin: ".5% 1.5%"}} onClick={() => {
                    setMessages([])
                    setMessageHistory("")
                    }} >{"\u27F3 chat"}</Button>
            </div>
            <Launcher
            agentProfile={{
                teamName: 'Chat with Sokrates',
                imageUrl: chatLogo
            }}
            onMessageWasSent={_onMessageWasSent}
            messageList={messages}
            isOpen={show}
            handleClick={_handleClick}
            showEmoji />
        </div>
    )
}